import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlass, ChatCircle, UserPlus, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

const Network = () => {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const load = async (qv = "") => {
    const r = await api.get(`/users${qv ? `?q=${encodeURIComponent(qv)}` : ""}`);
    setUsers(r.data);
  };
  useEffect(() => { load(); }, []);

  const connect = async (u) => {
    const r = await api.post(`/connections/${u.user_id}`);
    setUsers((arr) => arr.map(x => x.user_id === u.user_id ? { ...x, is_connected: r.data.connected } : x));
    toast.success(r.data.connected ? "CONNECTED" : "DISCONNECTED");
  };

  const startChat = async (u) => {
    const r = await api.post("/conversations", { other_user_id: u.user_id });
    navigate(`/app/messages/${r.data.id}`);
  };

  return (
    <div className="min-h-screen">
      <header className="border-b border-line p-6 flex items-end justify-between">
        <div>
          <div className="label-tag text-ink-3">// 02 — PEOPLE</div>
          <h1 className="font-heading font-black text-4xl mt-1">THE GRAPH</h1>
        </div>
        <div className="text-xs text-ink-3">{users.length} MEMBERS</div>
      </header>
      <div className="border-b border-line p-6 bg-white flex gap-3">
        <div className="flex-1 flex border border-line">
          <span className="px-3 flex items-center text-ink-3"><MagnifyingGlass size={16} /></span>
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && load(q)}
            placeholder="Search by name or headline…"
            data-testid="network-search"
            className="flex-1 p-3 text-sm bg-white"
          />
        </div>
        <button onClick={() => load(q)} className="btn-primary" data-testid="network-search-btn">SEARCH</button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
        {users.map((u) => (
          <div key={u.user_id} className="border-r border-b border-line p-6 bg-white" data-testid={`user-card-${u.user_id}`}>
            <div className="flex gap-4">
              <img src={u.picture || `https://api.dicebear.com/9.x/notionists/svg?seed=${u.user_id}`} className="w-16 h-16 border border-line object-cover" alt="" />
              <div className="flex-1 min-w-0">
                <div className="font-heading font-bold text-lg cursor-pointer hover:underline" onClick={() => navigate(`/app/profile/${u.user_id}`)}>{u.name}</div>
                <div className="text-xs text-ink-2 truncate">{u.headline || "Member"}</div>
                <div className="text-xs text-ink-3 truncate mt-1">{u.location}</div>
              </div>
            </div>
            <div className="mt-5 flex gap-2">
              <button onClick={() => connect(u)} className={`flex-1 text-xs uppercase tracking-wider py-2 ${u.is_connected ? "bg-paper-tint border border-line" : "btn-primary"}`} data-testid={`connect-${u.user_id}`}>
                {u.is_connected ? <><Check size={14} className="inline mr-1" /> CONNECTED</> : <><UserPlus size={14} className="inline mr-1" /> CONNECT</>}
              </button>
              <button onClick={() => startChat(u)} className="btn-secondary flex items-center gap-2" data-testid={`message-${u.user_id}`}>
                <ChatCircle size={14} /> CHAT
              </button>
            </div>
          </div>
        ))}
        {users.length === 0 && <div className="col-span-3 p-12 text-center text-ink-3 text-sm">— No members found. —</div>}
      </div>
    </div>
  );
};

export default Network;
